import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import useWindowSize from 'utils/hooks/useWindowSize';

import wnLogoSvg from 'images/logos/wn-logo-gold-gray.svg';
import Button from 'components/Buttons/Button';
import LandingPageSignInModal from './LandingPageSignInModal';

const LandingPageHeader = () => {
  const [bShowSignInModal, fnSetShowSignInModal] = useState(false);
  const oWindowSize = useWindowSize();

  return (
    <header className='landingPage__header'>
      <img
        src={wnLogoSvg}
        className='landingPage__headerLogo'
        alt='Wake Network logo'
      />
      <div>
        {oWindowSize.width >= 640 && (
          <Link
            to='/sign-up/help/noverify'
            className='landingPage__contactLink'
          >
            Contact Us
          </Link>
        )}
        <Button
          fnHandleClick={() => fnSetShowSignInModal(true)}
          className='landingPage__headerSignInButton'
        >
          Sign In
        </Button>
        {bShowSignInModal && (
          <LandingPageSignInModal fnSetShowSignInModal={fnSetShowSignInModal} />
        )}
      </div>
    </header>
  );
};

export default LandingPageHeader;
